
/*/ ## EF.Collections.QuestionsCollection
//
// Collection for the questions in a survey or assessment */
(function(EF, undefined) {

  var QuestionsCollection = Backbone.Collection.extend({
    model: EF.Models.Question
  });

  _.extend(EF.Collections, {
    QuestionsCollection: QuestionsCollection
  });

})(EF);
